define.alias("ember-composable-helpers/helpers/toggle-action", "calendar/helpers/toggle-action");